import { render } from "./GridTemplateColumns.vue?vue&type=template&id=00467db4&scoped=true&ts=true"
import script from "./GridTemplateColumns.vue?vue&type=script&lang=ts"
export * from "./GridTemplateColumns.vue?vue&type=script&lang=ts"

import "./GridTemplateColumns.vue?vue&type=style&index=0&id=00467db4&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00467db4"]])

export default __exports__